import { Show, TabbedShowLayout, type ShowProps } from "react-admin";
import RazaRequestCommitmentsPanel from "./RazaRequestCommitmentsPanel";
import RazaRequestWorkspace from "./RazaRequestWorkspace";
import RazaRequestsShowActions from "./RazaRequestsShowActions";
import { RazaRequestShowHeader } from "./RazaRequestShowHeader";

const RazaRequestsShow = (props: ShowProps) => (
  <Show {...props} actions={<RazaRequestsShowActions />}>
    <RazaRequestShowHeader />
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Request & lagat">
        <RazaRequestWorkspace section="request" />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Hall & events">
        <RazaRequestWorkspace section="hall-events" />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="One View">
        <RazaRequestCommitmentsPanel />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);

export default RazaRequestsShow;
